import axios from '@axios'

const route = 'register/common_area'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page }) {
      return axios.get(`${route}?page=${page}&items_per_page=${itemsPerPage}`)
    },
    store(context, room) {
      return axios.post(route, room)
    },
    update(context, room) {
      return axios.put(`${route}/${room.id}`, room)
    },
    delete(context, room) {
      return axios.delete(`${route}/${room.id}`)
    },

  },
}
